export const INTERNAL_LINKS = [
  { link: 'https://www.toptal.com/marketing/article-writers', label: 'Article Writers' },
  { link: 'https://www.toptal.com/marketing/blog-writers', label: 'Blog Writers' },
  { link: 'https://www.toptal.com/marketing/community-managers', label: 'Community Managers' },
  { link: 'https://www.toptal.com/marketing/copy-editors', label: 'Copy Editors' },
  { link: 'https://www.toptal.com/marketing/digital', label: 'Digital Marketers' },
  { link: 'https://www.toptal.com/marketing/ebook-writers', label: 'Ebook Writers' },
  { link: 'https://www.toptal.com/marketing/fractional-cmos', label: 'Fractional CMOs' },
  { link: 'https://www.toptal.com/marketing/google-ads', label: 'Google Ads Experts' },
  { link: 'https://www.toptal.com/marketing/influencer', label: 'Influencer Marketers' },
  { link: 'https://www.toptal.com/marketing/ppc-advertising', label: 'PPC Advertising Specialists' },
  { link: 'https://www.toptal.com/marketing/seo', label: 'SEO Experts' },
  { link: 'https://www.toptal.com/marketing/shopify-seo', label: 'Shopify SEO Experts' },
  { link: 'https://www.toptal.com/marketing/social-media-managers', label: 'Social Media Managers' },
  { link: 'https://www.toptal.com/marketing/social-media', label: 'Social Media Marketers' }
]
